module.exports = __webpack_public_path__ + "547ac200a1819e7c8d8e4902d1abf229.png";


//////////////////
// WEBPACK FOOTER
// ./js/index/img/about-1.png
// module id = 4
// module chunks = 0